<template>
  <div style="padding: 0px">
    <router-view />
    <SnackBar />
  </div>
</template>

<script>
import SnackBar from "../components/SnackBar";
import Constants from "../../constants";

export default {
    name: 'EmptyLayout',
    components: {SnackBar},
    created () { },
    methods: {
        goApp () {
            window.location.replace(Constants.BASE_URL + '/login');
        },
        golanding () {
            window.location.replace(Constants.LANDING_BASE_URL + '/landingPage');
        },
    }
};
</script>
